type Group = {
  key: 'regions' | 'years' | 'statuses';
  label: string;
  options: (string | number)[];
};

type Props = {
  groups: Group[];
  selected: Record<string, (string | number)[]>;
  onToggle: (key: 'regions' | 'years' | 'statuses', value: string | number) => void;
  onClear: () => void;
};

export default function FilterPanel({ groups, selected, onToggle, onClear }: Props) {
  const hasSelected = Object.values(selected).some((arr) => arr.length > 0);

  return (
    <div className="space-y-5">
      {groups.map((g) => (
        <div key={g.key}>
          <p className="mb-2.5 font-heading text-sm font-semibold text-foreground-900">{g.label}</p>
          <div className="flex flex-wrap gap-2">
            {g.options.map((opt) => {
              const active = selected[g.key]?.includes(opt);
              return (
                <button
                  key={String(opt)}
                  type="button"
                  onClick={() => onToggle(g.key, opt)}
                  className={`rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                    active
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
                  }`}
                >
                  {opt}
                </button>
              );
            })}
          </div>
        </div>
      ))}
      {hasSelected && (
        <button
          type="button"
          onClick={onClear}
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-accent-600"
        >
          <i className="ri-refresh-line" />
          清除全部筛选
        </button>
      )}
    </div>
  );
}